<template>
  <div id="zuCom">
    <ul class="ul_main">
      <li class="flex-box lis relativeItem" v-for="(n, i) in listData" :key="i">
        <div class="flex-box li_div">
          <div class="pai_con flex-box">
            <p v-if="i == 9">{{ i + 1 }}</p>
            <p v-else>0{{ i + 1 }}</p>
          </div>
          <div class="flex-box u_info">
            <div class="u_avt">
              <img
                class="imgBlock noevents-img"
                :src="n.heade_portrait"
                onerror="this.src = 'http://oss.3yakj.com/application_static_data/static_data/publicimg/img.jpg'"
              />
            </div>
            <div class="u_name apostrophe" v-if="n.nick_name != 'undefined'">
              {{ n.nick_name }}
            </div>
          </div>
        </div>

        <div class="flex-box rgt_box">
          <div class="flex-box">
            <i>贡献</i>
          </div>
          <p class="p2">{{ n.total_energy }}</p>
          <p>精力</p>
        </div>
      </li>
    </ul>
  </div>
</template>











<script>
export default {
  props: ["listData", "listText", "ahoUserText", "textCom"],
  data() {
    return {};
  },
  mounted() {},
  methods: {},
};
</script>












<style scoped>
.ul_main .pai_con {
  width: 40px;
  text-align: center;
  color: #fff;
  font-size: 15px;
  align-items: center;
  justify-content: center;
}
.pai_con img {
  width: 22px;
}
.lis {
  align-items: center;
  justify-content: space-between;
  padding: 12px 0;
  z-index: 2;
}
.lis:nth-child(even) {
  background-color: #ee7775;
}
.li_div {
  align-items: center;
}
.u_info {
  align-items: center;
  margin-left: 20px;
}
.u_info .u_avt {
  width: 1.875rem;
  height: 1.875rem;
}
.u_info .u_name {
  width: 76px;
  margin-left: 12px;
  color: #fff;
  font-size: 0.8125rem;
}
.u_avt img {
  width: 1.875rem;
  height: 1.875rem;
  border-radius: 50%;
}
.rgt_box {
  width: 39%;
  align-items: center;
  color: #fee1e2;
  font-size: 0.8125rem;
}
.rgt_box .p2 {
  color: #fee1e2;
  font-size: 0.875rem;
  padding-top: 2px;
  margin-left: 3px;
}
.ul_main li:nth-child(2n) {
  border-radius: 2rem;
}
i {
  font-style: normal;
}
</style>